"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertManagerContext = void 0;
var react_1 = require("react");
var AlertManagerContextState_1 = require("./AlertManagerContextState");
/**
 * AlertManagerContext
 *
 * Unified context to handle alerts
 *
 */
exports.AlertManagerContext = (0, react_1.createContext)(new AlertManagerContextState_1.AlertManagerContextState());
